/**
 * State used in rendering DrawerHeaderNavigation
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
